function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 2,
  fill: "#828CE8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.505 14.19C12.89 14.19 12.295 14.09 11.74 13.91C11.565 13.85 11.37 13.895 11.235 14.03L10.45 15.015C9.035 14.34 7.71 13.065 7.005 11.6L7.98 10.77C8.115 10.63 8.155 10.435 8.1 10.26C7.915 9.705 7.82 9.11 7.82 8.495C7.82 8.225 7.595 8 7.325 8H5.595C5.325 8 5 8.12 5 8.495C5 13.14 8.865 17 13.505 17C13.86 17 14 16.685 14 16.41V14.685C14 14.415 13.775 14.19 13.505 14.19Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19 9.5L15.6667 13V10.9H13V8.1H15.6667V6L19 9.5Z",
  fill: "white"
});

function SvgCallForwarding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallForwarding);
export default __webpack_public_path__ + "static/media/CallForwarding.494ed0c0.svg";
export { ForwardRef as ReactComponent };